<div class="pick" [class.on]="selected" (click)="pick.emit()">
  <ng-content select="[pick-lead]"></ng-content>
  <div class="pick-main">
    <div class="pick-title">{{ title }}</div>
    <div class="pick-sub" *ngIf="subtitle">{{ subtitle }}</div>
  </div>
  <ng-content select="[pick-trail]"></ng-content>
</div>
